<h3 style="text-align: center">Successfully sent</h3>
<p style="text-align: center">Your password reset link has been sent by email</p>

<div class="p-grid">
  <div class="p-col">
    <button pButton (click)="backToLogin()" label="Back to login" class="ui-button-secondary"></button>
  </div>
</div>
